import { supabase } from "./supabase";
import { fromDbWeather, toDbWeatherUpsert } from "../lib/mappers";

const WEATHER_COLUMNS =
  "id, dpr_id, time_slot, wind_speed, wind_dir, wind_height, sea_period, sea_height, swell_dir, swell_period, pitch, roll";

const listWeather = async (dprId) => {
  const { data, error } = await supabase
    .from("weather_entries")
    .select(WEATHER_COLUMNS)
    .eq("dpr_id", dprId)
    .order("time_slot", { ascending: true });

  if (error) throw error;
  return (data ?? []).map(fromDbWeather);
};

const upsertWeather = async (entries) => {
  if (!entries.length) return [];
  const payload = entries.map(toDbWeatherUpsert);

  const { data, error } = await supabase
    .from("weather_entries")
    .upsert(payload, { onConflict: "dpr_id,time_slot" })
    .select(WEATHER_COLUMNS);

  if (error) throw error;
  return (data ?? []).map(fromDbWeather);
};

export { listWeather, upsertWeather };
